/**
 * Etapa que dá o título da barra de jornada: a ativa (current/warning/error)
 * ou, sem etapa ativa, a última. Compartilhada entre a barra (ObjectSroJourney)
 * e o resumo lateral (ObjectSroDetail) para as duas telas dizerem a mesma coisa.
 */
export function journeyHeadStep(steps) {
  const list = Array.isArray(steps) ? steps : [];
  return (
    list.find((s) => s && ["current", "warning", "error"].includes(s.state)) ||
    list[list.length - 1] ||
    {}
  );
}
